import { Container, Col } from 'react-bootstrap'
import React from 'react'

import { InvoiceContainer } from '../../../molecules/invoice/SharedStyle'
import InvoiceDetails from '../InvoiceDetails'
import { Orders, Order, Customer } from '../../../molecules/invoice/purchase/types'

interface Props {
  pickingData: Orders
  query: string
  planId: string
  customer: Customer
}

const convertPaymentType = (type: number): string => {
  const types = ['Boleto', 'Cartão de crédito', 'Pix', 'Transferência']
  return types[type]
}

const allOrderItems = (orders: Order[]) => {
  const validItems = orders.map(({ items }: Order) => {
    return items.filter(
      (product: { category: string }) =>
        product.category !== 'Produtos Adicionados' && product.category !== 'Produtos Substituidos'
    )
  })
  return Array.prototype.concat(...validItems)
}

export const quantityOfInstallments = (orders: Order[]) => {
  return Math.max(1, ...orders.map((order) => order.quantityOfPaymentInstallments || 1))
}

const _Purchase = ({ pickingData, planId, customer }: Props) => {
  const productBuckets = allOrderItems(pickingData.orders)
  const payment = convertPaymentType(pickingData.orders[0].paymentType)
  const orderIds = pickingData.orders.map((order: any) => order.id)
  const creationDatetime = new Date(pickingData.orders[0].orderDatetime)
  const deliveryFee = pickingData.orders[0].deliveryFee
  const installments = quantityOfInstallments(pickingData.orders)

  return (
    <InvoiceDetails
      productBuckets={productBuckets}
      customer={customer}
      orderIds={orderIds}
      creationDatetime={creationDatetime}
      payment={payment}
      planId={planId}
      isDelivery={false}
      deliveryFee={deliveryFee}
      installments={installments}
    />
  )
}

const WrapTab = ({ pickingData, planId, customer }: Props) => {
  return (
    <>
      <InvoiceContainer>
        <Container>
          <Col className="m-2" style={{ backgroundColor: 'white' }}>
            <_Purchase pickingData={pickingData} customer={customer} planId={planId} query={''} />
          </Col>
        </Container>
      </InvoiceContainer>
    </>
  )
}

export default WrapTab
